import { ComponentType, ReactElement } from 'react';

import { protectFeature } from '~libs.shared.system';

export const withVisitSettlementGuard = <PROPS extends Record<string, unknown> & { children?: ReactElement }>(
   WrappedComponent: ComponentType<PROPS>
): ((props: PROPS) => JSX.Element | ReactElement | null) => {
   const Component = (props: PROPS): JSX.Element | ReactElement | null => {
      const settlingMedicalServicesPerformedByOneselfAvailable = protectFeature(
         'settlingMedicalServicesPerformedByOneself'
      );
      const settlingMedicalServicesPerformedByAnyPractitionerAvailable = protectFeature(
         'settlingMedicalServicesPerformedByAnyPractitioner'
      );
      const privateMedicalServicesReadOnlyAvailable = protectFeature('privateMedicalServicesReadOnly');

      if (
         settlingMedicalServicesPerformedByOneselfAvailable ||
         settlingMedicalServicesPerformedByAnyPractitionerAvailable ||
         privateMedicalServicesReadOnlyAvailable
      ) {
         return <WrappedComponent {...props} />;
      }

      return props.children ?? null;
   };

   Component.displayName = 'VisitSettlementGuard';
   return Component;
};
